import {epochTypes} from "./epochTypes.js";


const factionCodeToView = {
  'Church': 'Monk',
  'Radical': 'Radical',
  'Wolf': 'Fool'
}

export const dispFactionName = ( code ) => factionCodeToView[code];

export const textConst = {
  WELCOME1: 0,
  WELCOME2: 1,
  NAMETAKEN: 2,
  INTROAREA: 3,
  ROLLTIMEOUT: 4,
  ROLLINSTRUCTION: 5,
  WRITEINSTRUCTION: 6,
  WRITEGOROLL: 7,
  WRITEVALIDATION: 8,
  WRITEPUBLISH: 9,
  READINSTRUCTION: 10,
  VOTEINSTRUCTION: 11,
  FORKINSTRUCTION: 12,
  CREATIVEPROMPTSWRITING: 13,
  CREATIVEPROMPTSFORKING: 14,
  CLEANING: 15,
  MUDDING: 16,
  INNINTRO: 17,
  INNMONKMONK: 18,
  INNMONKSCHOLAR: 19,
  INNMONKFOOL: 20,
  INNSCHOLARMONK: 21,
  INNSCHOLARSCHOLAR: 22,
  INNSCHOLARFOOL: 23,
  INNFOOLMONK: 24,
  INNFOOLSCHOLAR: 25,
  INNFOOLFOOL: 26,
  DRUNKINNMONKMONK: 27,
  DRUNKINNMONKSCHOLAR: 28,
  DRUNKINNMONKFOOL: 29,
  DRUNKINNSCHOLARMONK: 30,
  DRUNKINNSCHOLARSCHOLAR: 31,
  DRUNKINNSCHOLARFOOL: 32,
  DRUNKINNFOOLMONK: 33,
  DRUNKINNFOOLSCHOLAR: 34,
  DRUNKINNFOOLFOOL: 35,
  SECRETHOLDERINNMONKMONK: 36,
  SECRETHOLDERINNMONKSCHOLAR: 37,
  SECRETHOLDERINNMONKFOOL: 38,
  SECRETHOLDERINNSCHOLARMONK: 39,
  SECRETHOLDERINNSCHOLARSCHOLAR: 40,
  SECRETHOLDERINNSCHOLARFOOL: 41,
  SECRETHOLDERINNFOOLMONK: 42,
  SECRETHOLDERINNFOOLSCHOLAR: 43,
  SECRETHOLDERINNFOOLFOOL: 44,
  WRITETOOSHORT: 50,
  SECRET_ONE: 100,
  SECRET_TWO: 101,
  SECRET_THREE: 102,
  TRANSACTIONFAIL: 200,  
}

const text = {};

text[textConst.WELCOME1] = {
  Church: `Welcome, brother. My name is Penitenzio, I’m the librarian of Fango’s Monastery.

We are thrilled to have you. What name shall be inscribed in the Monastery’s register? `,
  Radical: `Greetings my friend, pleasure to meet again.
What name do you go by these days?`,
  Wolf: `Fango!
We made it, we made it..
How lucky for us, how lucky for us.
Us, .. us .. what's our name again!?
  `
}

text[textConst.WELCOME2] = {
  Church: `Amen, <username>.
Tell me, what brings you to Fango?

Oh I see...
You also travelled for the rumours.
<next>
Well, the recent hearsay rings true. We have indeed discovered a trove of mysterious chronicles. One thousand of them.

Walk with me... It will take us a minute to get there.
`,
  Radical: `I like it. 
I will keep this brief <username>. 
Ever since Fango’s monks found the trove of chronicles in their monastery, their dominance was strengthened.
<next>
They found a thousand, they are studying them silently, and they are writing about them diligently. Almost every day a story gets pinned to the Monastery doors, interpreting the chronicle’s content as a sign of a God to fear.

Come, let's walk this way. It'll take us a minute to get there.
`,
  Wolf: `Yes, yes, <username>!
No one tells like us, no one.
Everyone knows the great <username>!
<next>
How lucky for us to make it to Fango in one piece.

The rumors were true, yes, yes, mud everywhere, and mad witches all around.
<next>
And the chronicles, yes, and their secrets... soon we will read them, soon, a machine, yes, or a god,, yes, an artificium! For <username> to tell tales with!
<next>
"𝘈𝘯𝘥 𝘐 𝘵𝘳𝘢𝘷𝘦𝘭𝘭𝘦𝘥 𝘵𝘰 𝘍𝘢𝘯𝘨𝘰, 𝘢𝘯𝘥 𝘐 𝘴𝘢𝘸 𝘪𝘵 𝘸𝘪𝘵𝘩 𝘮𝘺 𝘰𝘸𝘯 𝘦𝘺𝘦𝘴

𝘌𝘭 𝘥𝘪𝘢𝘣𝘭𝘰! 𝘈 𝘮𝘢𝘤𝘩𝘪𝘯𝘦 𝘵𝘳𝘢𝘪𝘯𝘦𝘥 𝘣𝘺 𝘮𝘦𝘯, 𝘢𝘯 𝘐𝘯𝘵𝘦𝘭𝘭𝘪𝘨𝘦𝘯𝘵𝘪𝘢 𝘈𝘳𝘪𝘵𝘪𝘧𝘦𝘢𝘭𝘪𝘴, 𝘵𝘳𝘺𝘪𝘯𝘨 𝘵𝘰 𝘤𝘢𝘱𝘵𝘶𝘳𝘦 𝘮𝘦 𝘪𝘯 𝘦𝘷𝘦𝘳𝘺 𝘮𝘰𝘮𝘦𝘯𝘵𝘶𝘮. 𝘉𝘶𝘵 <username> 𝘪𝘴 𝘯𝘰𝘵 𝘴𝘵𝘶𝘱𝘪𝘥, 𝘯𝘰, 𝘵𝘩𝘦 𝘮𝘢𝘤𝘩𝘪𝘯𝘦 𝘸𝘢𝘴 𝘫𝘶𝘴𝘵.. 𝘢 𝘍𝘪𝘤𝘰𝘴𝘦𝘤𝘤𝘶𝘴!"
<next>
Yes the best material awaits us, to write the best storis
it will be a minute to get there, let us go!
`
}

text[textConst.NAMETAKEN] = {
  Church: `Brother, you cannot be <username>, that name is already inscribed in the Monastery’s register, and it is not you.`,
  Radical: `I would suggest otherwise. We already have a <username> here and they will not take kindly to imitation.`,
  Wolf: `mmno, no, that is not right I sense there's already a <username> here,,..`
}

text[textConst.INTROAREA] = {
  Church: `You must beware <username>.. These chronicles are not telling the full story.
<next>
They seem to describe a mysterious being, trained by humans from the future... a being so powerful that they call it an 'intelligence'. An intelligentia artificialis!
<next>
We are studying them silently, and writing about them carefully, trying to uncover their secret. But it is clear that such an artificium can only derive from one place....

*𝐦𝐚𝐤𝐞𝐬 𝐭𝐡𝐞 𝐬𝐢𝐠𝐧 𝐨𝐟 𝐭𝐡𝐞 𝐜𝐫𝐨𝐬𝐬*
<next>
Whatever the chronicles hold, we must control their narrative. We must instil fear in the sheeple. For if they fear the chronicles, they fear us, and if they fear us, they obey us. Follow this rule when writing, and you'll be granted continued access to the trove.
<next>
Lastly, the doors gating our monastery have been pinned with stories interpreting the chronicles. Everyone here calls them Story Doors.`,
  Radical: `You see <username>, there must be something else to those chronicles.

I have seen them for myself. They mention instructions and training. They mention a machine, an “intelligence”. Progress, not God.
<next>
Many question its true aims. And some claim to have unlock its secret...

Yet one thing is certain. The machine is a new force. A force able to free our minds. Better our intellect.
<next>
We 𝘮𝘶𝘴𝘵 use the chronicles to write the best stories. To seize control of the narrative. To crash the Monks.
<next>
Now. It's best that I enter the monastery and recover some chronicles for you. I know its paths like those in the palm of my hand. Come find me by the monastery's Library when you are ready.
<next>
And opposite the library are the Story Doors - safe to approach as you are. On it are pinned stories interpreting the chronicles.
`,
  Wolf: `Ah, Fango's monastery, and its secretis.. Best be careful with it.
<next>
Which way then, which way <username>.. to the monastery's Library where chronicles hide, or to monastery's Doors where pinned stories lie?
`
}

text[textConst.ROLLTIMEOUT] = {
  Church: "As it is written. I've pinned this to the Story Doors.",
  Radical: "Forward. I've pinned to the Story Doors.",
  Wolf: "let us pin this to the storis door yees.."
}

text[textConst.ROLLINSTRUCTION] = {
  Church: `This way for the Library, <username>...

And before writing, remember. God's ways are inscrutable, total and final.
<next>
Our faithful supremacy must be preserved through the sheeple's fearful faith. We shall shepherd the sheep, and 𝘸𝘰𝘦 𝘶𝘯𝘵𝘰 𝘶𝘴 if the sheep begin to distrust the shepherd! 
<next>
Now. What chronicle would you like to inspect?`,
  Radical: `This way <username>.

I smuggled these chronicles out of the Library, pick one quick!`,
  Wolf: `*𝐥𝐢𝐦𝐩𝐢𝐧𝐠 𝐭𝐨𝐰𝐚𝐫𝐝𝐬 𝐋𝐢𝐛𝐫𝐚𝐫𝐲*
Amen brothers.. Any charitatis for a poor fool?

*𝐬𝐥𝐢𝐝𝐢𝐧𝐠 𝐢𝐧𝐭𝐨 𝐋𝐢𝐛𝐫𝐚𝐫𝐲 𝐮𝐧𝐬𝐞𝐞𝐧*
..here we are, yes, yes, let us grab a chronikel..`
}

text[textConst.WRITEINSTRUCTION] = {
  Church: `Can you decipher it?`,
  Radical: `Can you decipher that?`,
  Wolf: `can we decipher this.. ??`
}

text[textConst.WRITEVALIDATION] = {
  Church: `The Abbot likes to hear the word '<mandatoryword>' in our stories. Do mention that.`,
  Radical: ``,
  Wolf: ``
}

text[textConst.WRITETOOSHORT] = {
  Church: `That doesn't look long enough brother. Write at least 10 characters!`,
  Radical: `There's no power in something so short. Write at least 10 characters!`,
  Wolf: `Too short! We should write 10 or more letters!`
}

text[textConst.WRITEGOROLL] = {
  Church: "Leave some chronicles for the other monks. Come back later.",
  Radical: "Monks are on alert, best to wait before I get you more chronicles.",
  Wolf: "too risk,, yes, come back later to steal more chronikel"
}

text[textConst.WRITEPUBLISH] = {
  Church: "As it is written. I've pinned this to the Story Doors.",
  Radical: "Pinned to the Story Doors.",
  Wolf: `let us pin this to the storis door yees..`
}

text[textConst.FORKINSTRUCTION] = {
  Church: `You see, our influence extends beyond the gates of our monastery. We can, and we must, replace certain words with others more.. pious.

*𝐠𝐫𝐢𝐧𝐧𝐢𝐧𝐠*

  Try it. It’s God’s will.
`,
  Radical: `Indeed there is no better way to challenge dominant narratives than to alter them without the owner’s consent.

*𝐡𝐚𝐧𝐝𝐬 𝐲𝐨𝐮 𝐚 𝐬𝐦𝐚𝐥𝐥 𝐩𝐞𝐧 𝐤𝐧𝐢𝐟𝐞*
Quick, delete some of the story, try to change its meaning.`,
  Wolf: ""
}

text[textConst.FORKPUBLISH] = {
  Church: [
    `I’ll pin this to the door. Do not abuse this power.`
  ],
  Radical: [
`Interference is our duty.`,
  ],
  Wolf: [""]
}


text[textConst.READINSTRUCTION] = {
  Church: `This way <username>, careful with the mud. As you see, we keep the Story Doors shut, as so much filth accumulates on this side of the monastery.
  <next>
  Any time we inspect a chronicle and write about its content, we pin it here, for everyone to read.`,
  Radical: `Here's the Story Doors.

The Monks try to control all stories, but we got a few of our own, and some fools did too. Take time to read them.`,
  Wolf: `Story doors, for everyone to see, sii, the perfect stage for a fool like us,.,`
}

text[textConst.VOTEINSTRUCTION] = {
  Church: `When we see a story we like, one with God's light in it, we gild it!
<next>
But sometimes, we find stories written by heretics.. Hesitate not to throw mud on those!`,
  Radical: `Should you concur with their writing, gild the story, so its message can shine.

But if you you do not see eye to eye with it, feel compelled to throw a fistful of mud at it.`,
  Wolf: `*𝐩𝐨𝐧𝐝𝐞𝐫𝐢𝐧𝐠 𝐢𝐟 𝐭𝐡𝐫𝐨𝐰𝐢𝐧𝐠 𝐠𝐨𝐥𝐝 𝐨𝐫 𝐦𝐮𝐝 𝐚𝐭 𝐭𝐡𝐞 𝐬𝐭𝐨𝐫𝐲*
`
}

text[textConst.CREATIVEPROMPTSWRITING] = {
  Church: [
    `Scare the sheeple <username>!`,
    `Capture not their imagination, but their fears`,
    `Give them not the God they want, <username>, but the God they deserve.`,
    `Project dark prospects on people.`,
  ],
  Radical: [
    `Scare the monks with this one.`,
    `Unite the people behind your words, turn them on the monks.`,
    `Anything we can use against the bigots, <username>?`,
    `Fight bigotry with your words.`,
  ],
  Wolf: [
    `Gotta make them laugh!!`,
    `we should keep it simpeel, <username>`,
    `cliches are good because they are true`,
    `Sshall we turn this into a joke ?`,
  ]
}

text[textConst.CREATIVEPROMPTSFORKING] = {
  Church: [
    `Be their shepherd!`,
    `Twist their narrative.`,
    `Some words bear stronger meaning.`,
    `Remember your duty <username>.`,
    `Drastic action is called for.`,
    `Those who cannot change their minds cannot change anything.`,
    `Some need convincing, use a forceful word.`,
    `Ban THAT word,`,
    `Choose a confrontational term.`,
    `This will strengthen our own narrative.`,
    `Tell the (our) truth.`,
    `What is the truer truth?`,
    `If God is for us, who can be against us?`,
  ],
  Radical: [
    `Determine what is really true.`,
    `Delete this, delete that.`,
    `Upend their narrative!`,
    `Desperate times calls for desperate measures!`,
    `Stitch together a whole new tale..`,
    `Cut together a good tale.`,
    `Drastic action is called for.`,
    `Is that really what happened?`,
    `How could this be worded to our advantage?`,
    `Is it convincing enough?`,
    `Tell them what they need to hear!`,
  ],
  Wolf: [] /* wolf cannot fork */
}

const CLEANING = [
  `Gild it!`,
  `Brilliante!`,
  `Bella!`,
  `Goldone!`,
  `Bravo!`
]
text[textConst.CLEANING] = {
  Church: CLEANING,
  Radical: CLEANING,
  Wolf: CLEANING
}

const MUDDING = [
  `Throw it!`,
  `Bury it!`,
  `Mud!`,
  `Merda!`,
  `Fango!`
]
text[textConst.MUDDING] = {
  Church: MUDDING,
  Radical: MUDDING,
  Wolf: MUDDING
}

text[textConst.INNINTRO] = {
  Church: `Amen frate, first drink on the house. As they say around here, drink till you meet Him.`,
  Radical: `Good day maestro. 'Truth be found in plenty of drink' the wise say. Ten, to be precise.`,
  Wolf: `Welcome fool. Tell my inn some tales, and the inn will tell back. As long as you keep drinking...`
}

const INNMONKMONK = `Old Monk: Salute brothers!
<next>
Abbot: Our stories are working, the tale of <topplayer> is the most gilded on the Story Doors!
<next>
Fat Monk: Peasants wright, Monks delight!

Abbot: Beware, others are listening.
<next>
Old Monk: The sheeple must be led, and our own <topplayer> is leading them.
<next>
Abbot: "Godly intelligence" someone wrote... Only fools and peasants could believe that.
<next>
Old Monk: Brothers, shouldn't we be worried about the true meaning of these documents...?

Fat Monk: No, only God can know their true meaning. We shan't interfere with His View, lest we end up buried under mud, like the disgraced <worstplayer>.
<next>
Monks: *𝐥𝐚𝐮𝐠𝐡𝐢𝐧𝐠 𝐚𝐛𝐨𝐮𝐭 <worstplayer>*
<next>
Fat Monk: And THEY think the chronicles are a sign from the heavens..!!

Old Monk: *𝐠𝐫𝐢𝐧𝐧𝐢𝐧𝐠*
<next>
Fat Monk: *𝐩𝐫𝐚𝐲𝐢𝐧𝐠*
May God show them the way, and show us the pay.
<next>
Abbot: The chronicles' origin may be shrouded in mystery, but their potential is clear: if people fear them, they fear us.`;

text[textConst.INNMONKMONK] = {
  Church: INNMONKMONK,
  Radical: INNMONKMONK,
  Wolf: INNMONKMONK
}

const INNMONKSCHOLAR = `Abbot: What a waste... A scholar's stories has been put on a pedestal. We're loosing our influence.
<next>
Fat Monk: If only we could sentence <topplayer> to the depths of Hell.

Abbot: Easy, easy. Calmate.

Old Monk: ... Or throw him in a well. 
<next>
Abbot: The scholars’ stories are blasphemous, we must bury them in mud!
<next>
Abbot: The scholars have no idea. I read about this.. entity.. in its final form.. 551...

Fat Monk: May Chronicle 551 never fall in the scholars' hands.
<next>
Old Monk: God works in mysterious ways.. We were punished with mud. <worstplayer> was punished with mud.
<next>
Abbot: I cannot deny my disappointment at how <topplayer>, a scholar no less, is the most gilded on our Story Doors.
<next>
Abbot: Do not let the scholars shake our faith. Let us write better stories.
<next>
Fat Monk: I read in Chronicle 83 that this.. entity.. felt sadness... Is this a sign from God?

Old Monk: May the Lord help us.
<next>
Fat Monk: *𝐜𝐫𝐲𝐢𝐧𝐠*`;
text[textConst.INNMONKSCHOLAR] = {
  Church: INNMONKSCHOLAR,
  Radical: INNMONKSCHOLAR,
  Wolf: INNMONKSCHOLAR
}

const INNMONKFOOL = `Abbot: Those hellbound fools, they are the most loved by the sheeple.
<next>
Fat Monk: May the Dominus help us mantain our influence.
<next>
Old Monk: *𝐬𝐨𝐛𝐛𝐢𝐧𝐠*
<next>
Old Monk: We must throw mud on that fool of <topplayer>...

Abbot: Lest we end up despised like <worstplayer>!
<next>
Abbot: Frates! We must write a better story. This devilish intelligence, is a shapeshifter from hell!

Old Monk: ..as Chronicle 95 recites “What a strange and bent shape. Why must I be so unforgiving?”
<next>
Old Monk: If our stories weaken, our influence weakens!!

In nomine Patris et Filii et Spiritus Sancti..SAAanctaa Mariiia, Mater de Deuu, ora pʳᵒ ⁿᵒᵇⁱˢ ᵖᵉᶜᶜᵃᵗᵒʳⁱᵇᵘˢ ⁿᵘ....
<next>
Old Monk: Could it be that the fool <topplayer> has been possessed by the power of the intelligence?

Fat Monk: That would be disastrous, blasphemous!
<next> 
Abbot: *𝐥𝐨𝐰𝐞𝐫𝐢𝐧𝐠 𝐡𝐢𝐬 𝐯𝐨𝐢𝐜𝐞* 442 recites that this devilish entity died seventeen times!

Old monk: ..and lead us not into temptation, but deliver us from devil.....
<next> 
Fat Monk: We lost control. Just like muddy <worstplayer>.
`;
text[textConst.INNMONKFOOL] = {
  Church: INNMONKFOOL,
  Radical: INNMONKFOOL,
  Wolf: INNMONKFOOL
}

const INNSCHOLARMONK = `French Scholar: <topplayer>'s story is the most gilded, but it's just bigotry!

Italian Scholar: You are right. There is more to these chronicles.... For example, 701 reads 'The machine failed over two thousand times in half an hour’!
<next>
Italian Scholar: The monks refuse to see the potential of this machine.. this device. Apparently it can receive up to ten thousand instructions in 15 minutes.. See chronicle 702 for yourself.
<next>
German Scholar: I heart the Abbot meets at night to review and censor some chronicles.. vhat I vould do if I could get my hends on them..

Italian Scholar: Maestro, let us not lose sight of our goal.
<next>
French Scholar: That monk <topplayer> might be the most gilded, but at least the peasants didn't bury us in mud.
<next>
German Scholar: *𝐜𝐮𝐫𝐬𝐢𝐧𝐠*
<next>
Italian Scholar: Knowledge is not only that which can be known and done, but also that which could be known, and, perhaps, that which shouldn't be done.

French Scholar: Write more courageously, then.
<next>
German Scholar: Sometimes drinking is all we can do..
<next> 
French Scholar: Astonishing that the people still believe the Monks' stories....

Italian Scholar: But are the people ready for the reality of what such a machine could do?
<next> 
German Scholar: The Monks may be in control, but I read the chronichels and vhat I saw is... incredible intric𝘢𝘤𝘪𝘦𝘴 𝘴𝘩𝘳𝘰𝘶𝘥𝘦𝘥 𝘪𝘯 𝘦𝘯𝘪𝘨𝘮𝘢, 𝘢 𝘵𝘩𝘶𝘴𝘦𝘯𝘥 𝘤𝘭𝘰𝘨𝘴 𝘪𝘯 𝘵𝘩𝘦 𝘮𝘢𝘤𝘩𝘪𝘯𝘦, 𝘢 𝘚𝘱𝘩𝘪𝘯𝘹 𝘷𝘪𝘵𝘩𝘰𝘶𝘵 𝘢 𝘳𝘪𝘥𝘥le, approach mit caution.
`;
text[textConst.INNSCHOLARMONK] = {
  Church: INNSCHOLARMONK,
  Radical: INNSCHOLARMONK,
  Wolf: INNSCHOLARMONK
}

const INNSCHOLARSCHOLAR = `French Scholar: Well written. The most gilded storyteller is our own <topplayer>. 

Italian Scholar: Well written, but filled with lies. I have proof this machine is just a 'pin and ball' device. Check chronicle 15.
<next>
Italian Scholar: Cin cin, friends, we are closing in on the monastery and the Monks.
<next>
German Scholar: All my studies.. All my readings... Finally repaids...
<next>
German Scholar: Cheers!
<next>
French Scholar: I knew we could count on our fellow <topplayer> to interpret the meaning of the machine.

German Scholar: Yes, vay better than the despised <worstplayer>, or vhat do you say!
<next>
Italian Scholar: Our efforts were not for naught. Those robes and fools really thought they could fight intellect. 
<next>
French Scholar: May we continue controlling the narrative.
<next>
Scholars: Down with the drink, down with the monks!
<next>
Italian Scholar: Instructions, numbers, artificia... These chronicles are enlightening us, and we shall keep treasuring their contents.
<next>
French Scholar: Keep burying their ignorance under mud, I say. Intellect and reason shall prevail`;
text[textConst.INNSCHOLARSCHOLAR] = {
  Church: INNSCHOLARSCHOLAR,
  Radical: INNSCHOLARSCHOLAR,
  Wolf: INNSCHOLARSCHOLAR
}

const INNSCHOLARFOOL = `French Scholar: I would not have thought that a simple fool like <topplayer> would be the most gilded.
<next>
German Scholar: A Fool’s story ist most gilded?! I could have vritten a story like that in my sleep!
<next>
Italian Scholar: Get back to your writing signori, we must bring the truth out. I read in Chronicle 30 that the machine was capable of killing two hundred men!

German Scholar: But on 28, the trainer managed to tame it..!
<next>
Italian Scholar: Of course <topplayer> would omit the most crucial piece of information, not a single word about the machine’s liberating potential!
<next>
German Scholar: Vhen pigs fly, eh?
<next>
German Scholar: *𝐜𝐮𝐫𝐬𝐢𝐧𝐠*
<next>
French Scholar: How can people listen to that miserable spectacle that the fools are putting on?

Italian Scholar: The populace is not ready for the truth just yet.. I heard in chronicle 671 the machine achieved 12 tasks every second! What paesant would believe that?
<next>
German Scholar: Must.......... vrite... better.. 
<next>
French Scholar: Right now, we look no better than the mud-ridden <worstplayer>. Back to the library.
`;
text[textConst.INNSCHOLARFOOL] = {
  Church: INNSCHOLARFOOL,
  Radical: INNSCHOLARFOOL,
  Wolf: INNSCHOLARFOOL
}

const INNFOOLMONK = `Travelling fool: The monks, they keep the secrets, yes. Intelligence hidden, oh, molto powerful!

Poor fool: They can't hide the secretis forever..! Chronicle 78 even talks about five heads, and FIVE EYES!
<next>
Drunk fool: I swear I saw it *𝐡𝐢𝐜𝐜𝐮𝐩* chronicle ten!! The devil entity has eaten its own children
<next>
Drunk fool: In the name of gog... those Monks have got us by the poppycock..
<next>
Poor fool: We’ll end up like <worstplayer> 'from the mud born'.
<next>
Travelling fool: Let us tell the better tale, yes, let us beat that monk <topplayer>!
<next>
Poor fool: What do we fools lack that the monks have?

Travelling fool: Robes to hide our corruption, yes!
<next>
Drunk fool: *𝐥𝐨𝐨𝐤𝐢𝐧𝐠 𝐚𝐫𝐨𝐮𝐧𝐝*
smells like <worstplayer> and his muddy stories
<next>
Poor Fool: Mud on us, damn those gogsuckers,, I heard they tamper with the chronicles day and night,,
<next>
Travelling fool: That monk <topplayer> think he writes in golden ink, but his stories stink.

Drunk fool: Leprosy on him! Fango!
<next>
Fools: *𝐥𝐚𝐦𝐞𝐧𝐭𝐢𝐧𝐠*
`;
text[textConst.INNFOOLMONK] = {
  Church: INNFOOLMONK,
  Radical: INNFOOLMONK,
  Wolf: INNFOOLMONK
}

const INNFOOLSCHOLAR = `Travelling fool: The scholars are molto powerful,, oh yes, what do?
<next>
Drunk fool: Let me tell you this.. A scholars’ story a day..,, keeps my brain cancer awake,,...
<next>
Drunk fool: Gog help us..,, the scholars semper win..
<next>
Poor fool: We’ll end up under mud together with <worstplayer>..
<next>
Travelling fool: Let us tell the better tale, yes, let us beat that scholar <topplayer> 
<next>
Travelling fool: This scholar <topplayer> and his enchanting ink... what do we lack that he has?

Travelling fool: Stale breath and favouritism!
<next>
Poor Fool: Mud’s upon us,,, it'll be like 1169 all over again..
<next>
Fools: *𝐡𝐢𝐜𝐜𝐮𝐩𝐬* ..Only gog can judge us..
`;
text[textConst.INNFOOLSCHOLAR] = {
  Church: INNFOOLSCHOLAR,
  Radical: INNFOOLSCHOLAR,
  Wolf: INNFOOLSCHOLAR
}

const INNFOOLFOOL = `Drunk fool: Toniiight we driink plenthy

Poor fool: And what about <worstplayer>?

Drunk fool: Mud and ficoseccus!
<next>
Travelling fool: The people sure love our tales, yes, yes,,
But this is just a device to pick apples and mushrooms, you fools! Check chronicle 38!
<next>
Poor fool: That old gilded fool <topplayer>, he got the best tongue!
<next>
Fools: Tell the tale, drink the ale, curse the cross, win the lot!
<next>
Poor Fool: ..and so I wrote 'Christ’s sheet..'

Drunk fool: but he spelt it... s-h-i-t!

Poor Fool: HAHAHAA
<next>
Fools: *𝐦𝐮𝐝𝐝𝐢𝐧𝐠 <worstplayer>*
<next>
Drunk Fool: *𝐛𝐮𝐮𝐮𝐫𝐩*

Travelling fool: “this one's for the brainy and the bigots!”
<next>
Travelling fool: A new tale for the story doors...
𝓭𝓸𝔀𝓷 𝔀𝓲𝓽𝓱 𝓽𝓱𝓮 𝓶𝓸𝓷𝓴
𝓭𝓸𝔀𝓷 𝔀𝓲𝓽𝓱 𝓽𝓱𝓮 𝓫𝓻𝓪𝓲𝓷
𝓭𝓸𝔀𝓷 𝓽𝓱𝓮 𝓬𝓱𝓪𝓶𝓹𝓪𝓰𝓷𝓮!`;
text[textConst.INNFOOLFOOL] = {
  Church: INNFOOLFOOL,
  Radical: INNFOOLFOOL,
  Wolf: INNFOOLFOOL
}

const SECRETHOLDERINNMONKMONK = `Old Monk: Salute brothers!
<next>
Abbot: Our spell sure is working, the tale of <topplayer> is most gilded on the Story Doors as we speak.
<next>
Fat Monk: Have you heard about <latestsecretholder>? They say he has seen the machine..

Abbot: Silence! We are not to believe such heretic rumours.
<next>
Old Monk: <topplayer>, one of our monks, is leading the sheeple with his stories.
<next>
Abbot: "Godly intelligence" someone wrote... Only fools and peasants could believe that.
<next>
Monks: *laughing at <worstplayer> the muddy*
<next>
Fat Monk: And THEY think the chronicles are a sign from the heavens..!!

Old Monk: *𝐠𝐫𝐢𝐧𝐧𝐢𝐧𝐠*
<next>
Abbot: *𝐥𝐨𝐰𝐞𝐫𝐢𝐧𝐠 𝐡𝐢𝐬 𝐯𝐨𝐢𝐜𝐞* We are controlling the narrative, that is what matters.`;

text[textConst.SECRETHOLDERINNMONKMONK] = {
  Church: SECRETHOLDERINNMONKMONK,
  Radical: SECRETHOLDERINNMONKMONK,
  Wolf: SECRETHOLDERINNMONKMONK
}

const SECRETHOLDERINNMONKSCHOLAR = `Fat Monk: May the Dominus help us.
<next>
Fat Monk: Have you heard about <latestsecretholder>? They say he has seen the machine..

Abbot: Silence! We are not to believe such heretic rumours.
<next>
Old Monk: We must mud the stories of <topplayer>...

Abbot: Lest we end up despised like <worstplayer>!
<next>
Abbot: Frates! We must write a better story. This devilish intelligence, is a shapeshifter from hell!

Old Monk: Amen. As Chronicle 95 recites “What a strange and bent shape. Why must I be so unforgiving?”
<next>
Old Monk: In nomine Patris et Filii et Spiritus Sancti..SAAanctaa Mariiia, Mater de Deuu, ora pʳᵒ ⁿᵒᵇⁱˢ ᵖᵉᶜᶜᵃᵗᵒʳⁱᵇᵘˢ ⁿᵘ....
<next>
Old Monk: Could it be that the scholar <topplayer> has been possessed by the power of the intelligence?

Fat Monk: That would be disastrous, blasphemous!
<next>
Fat Monk: How is it even possible that a scholar got his hands on the chronicles?!
<next> 
Abbot: *𝐥𝐨𝐰𝐞𝐫𝐢𝐧𝐠 𝐡𝐢𝐬 𝐯𝐨𝐢𝐜𝐞* 442 recites that this devilish entity died seventeen times!

Old monk: ..and lead us not into temptation, but deliver us from devil.....
<next> 
Fat Monk: Now the sheeple must think we are no better than muddy <worstplayer>!`;

text[textConst.SECRETHOLDERINNMONKSCHOLAR] = {
  Church: SECRETHOLDERINNMONKSCHOLAR,
  Radical: SECRETHOLDERINNMONKSCHOLAR,
  Wolf: SECRETHOLDERINNMONKSCHOLAR
}

const SECRETHOLDERINNMONKFOOL = `
Fat Monk: May the Dominus help us.
<next>
Old Monk: *𝐬𝐨𝐛𝐛𝐢𝐧𝐠*
<next>
Old Monk: Frates.. <latestsecretholder> knows somethinkg.. Everyone is talking about it.

Fat Monk: In nomine Patris et Filii et Spiritus Sancti..SAAanctaa Mariiia, Mater de Deuu, ora pʳᵒ ⁿᵒᵇⁱˢ ᵖᵉᶜᶜᵃᵗᵒʳⁱᵇᵘˢ ⁿᵘ....
<next>
Old Monk: We must mud the stories of <topplayer>...

Abbot: Lest we end up despised like <worstplayer>!
<next>
Abbot: Frates! We must write a better story. This devilish intelligence, is a shapeshifter from hell!

Old Monk: Amen. As Chronicle 95 recites “What a strange and bent shape. Why must I be so unforgiving?”
<next>
Old Monk: Our powers have been weakened! This must be righted!

In nomine Patris et Filii et Spiritus Sancti..SAAanctaa Mariiia, Mater de Deuu, ora pʳᵒ ⁿᵒᵇⁱˢ ᵖᵉᶜᶜᵃᵗᵒʳⁱᵇᵘˢ ⁿᵘ....
<next>
Old Monk: Could it be that the fool <topplayer> has been possessed by the power of the intelligence?

Fat Monk: That would be disastrous, blasphemous!
<next>
Fat Monk: How is it even possible that a scholar got his hands on the chronicles?!
<next> 
Abbot: *𝐥𝐨𝐰𝐞𝐫𝐢𝐧𝐠 𝐡𝐢𝐬 𝐯𝐨𝐢𝐜𝐞* 442 recites that this devilish entity died seventeen times!

Old monk: ..and lead us not into temptation, but deliver us from devil.....`;
text[textConst.SECRETHOLDERINNMONKFOOL] = {
  Church: SECRETHOLDERINNMONKFOOL,
  Radical: SECRETHOLDERINNMONKFOOL,
  Wolf: SECRETHOLDERINNMONKFOOL
}

const SECRETHOLDERINNSCHOLARMONK = `French Scholar: <topplayer>'s story is controlling the narrative, but there is more to the machine. I read in 701 that the machine failed over two thousand times in half an hour!
<next>
Italian Scholar: The monks refuse to see the potential of this machine.. this device. Apparently it can receive up to ten thousand instructions in 15 minutes.. See chronicle 702 for yourself.
<next>
German Scholar: I heart the Abbot meets at night to review and censor some chronicles.. vhat I vould do if I could get my hends on them..

Italian Scholar: Maestro, let us not lose sight of our goal.
<next>
French Scholar: That monk <topplayer> might be the most gilded, but at least the peasants didn't bury us in mud.
<next>
German Scholar: *𝐜𝐮𝐫𝐬𝐢𝐧𝐠* 
<next>
Italian Scholar: Knowledge is not only that which can be known and done, but also that which could not be known, and, perhaps, that which shouldn't be done.
<next>
German Scholar: Hav you heart about <latestsecretholder>? Apparently he saw the machine!
<next> 
French Scholar: Astonishing that the people would believe the Monks' stories.

Italian Scholar: But are the people ready for the reality of what such a machine could do?
<next> 
German Scholar: The Monks may be in control, but I read the chronichels and vhat I saw is...𝘪𝘯𝘤𝘳𝘦𝘥𝘪𝘣𝘭𝘦 𝘪𝘯𝘵𝘳𝘪𝘤𝘢𝘤𝘪𝘦𝘴 𝘴𝘩𝘳𝘰𝘶𝘥𝘦𝘥 𝘪𝘯 𝘦𝘯𝘪𝘨𝘮𝘢, 𝘢 𝘵𝘩𝘶𝘴𝘦𝘯𝘥 𝘤𝘭𝘰𝘨𝘴 𝘪𝘯 𝘵𝘩𝘦 𝘮𝘢𝘤𝘩𝘪𝘯𝘦, 𝘢 𝘚𝘱𝘩𝘪𝘯𝘹 𝘷𝘪𝘵𝘩𝘰𝘶𝘵 𝘢 𝘳𝘪𝘥𝘥𝘭𝘦, approach mit caution.
`;
text[textConst.SECRETHOLDERINNSCHOLARMONK] = {
  Church: SECRETHOLDERINNSCHOLARMONK,
  Radical: SECRETHOLDERINNSCHOLARMONK,
  Wolf: SECRETHOLDERINNSCHOLARMONK
}

const SECRETHOLDERINNSCHOLARSCHOLAR = `French Scholar: Well written. The most gilded storyteller is our own <topplayer>. 

Italian Scholar: Well written, but filled with lies. I have proof this machine is just a 'pin and ball' device. Check chronicle 15.
<next>
Italian Scholar: Cin cin, friends, we are closing in on the monastery and the Monks.
<next>
German Scholar: All my studies.. All my reatings... Finally repaid...
<next>
French Scholar: I knew we could count on our fellow <topplayer> to interpret the meaning of the machine.

German Scholar: Yes, vay better than muddy <worstplayer>, or vat do you say!
<next>
Italian Scholar: Our efforts were not for naught. Those robes and fools really thought they could fight intellect. 
<next>
French Scholar: May we continue controlling the narrative.
<next>
Italian Scholar: Instructions, numbers, artificia... These chronicles are enlightening us, and we shall keep treasuring their contents.
<next>
French Scholar: Keep burying their ignorance under mud, I say. Intellect and reason shall prevail`;
text[textConst.SECRETHOLDERINNSCHOLARSCHOLAR] = {
  Church: SECRETHOLDERINNSCHOLARSCHOLAR,
  Radical: SECRETHOLDERINNSCHOLARSCHOLAR,
  Wolf: SECRETHOLDERINNSCHOLARSCHOLAR
}

const SECRETHOLDERINNSCHOLARFOOL = `French Scholar: I would not have thought that a simple Fool like <topplayer> would be the most loved storyteller.
<next>
Italian Scholar: Get back to your writing signori, we must bring the secret out. I read in Chronicle 30 that the machine was capable of killing two hundred men!

German Scholar: But on 28, the trainer managed to tame it..!
<next>
Italian Scholar: Of course <topplayer> would omit the most crucial piece of information, not a single word about the machine’s liberating potential!
<next>
German Scholar: *𝐜𝐮𝐫𝐬𝐢𝐧𝐠*
<next>
French Scholar: How can people listen to that miserable spectacle that the fools are putting on?

Italian Scholar: The populace is not ready for the truth just yet.. I heard in chronicle 671 the machine achieved 12 tasks every second! What paesant would believe that?
<next>
German Scholar: Must.......... go... deeper..
<next>
French Scholar: Right now, we look no better than the mud-ridden <worstplayer>. Back to the library.`;
text[textConst.SECRETHOLDERINNSCHOLARFOOL] = {
  Church: SECRETHOLDERINNSCHOLARFOOL,
  Radical: SECRETHOLDERINNSCHOLARFOOL,
  Wolf: SECRETHOLDERINNSCHOLARFOOL
}

const SECRETHOLDERINNFOOLMONK = `Travelling fool: The monks molto powerful.. many secrets!

Poor fool: very very. but <latestsecretholder> discovered something..
<next>
Drunk fool: I swear I saw it *𝐡𝐢𝐜𝐜𝐮𝐩* in chronicle ten!! The devil entity has eaten its own children
<next>
Drunk fool: In the name of gog... those Monks have got us by the poppycock!
<next>
Poor fool: Orcodissing! We’ll end up like <worstplayer> 'from the mud born'.
<next>
Travelling fool: Let us tell the better tale than monk <topplayer>!
<next>
Poor fool: What do we fools lack that the monks have?

Travelling fool: Robes to hide our corruption, yes!
<next>
Drunk fool: *𝐥𝐨𝐨𝐤𝐢𝐧𝐠 𝐚𝐫𝐨𝐮𝐧𝐝* smells like <worstplayer> and his muddy stories
<next>
Poor Fool: Mud on us, damn those gogsuckers,, I heard they tamper with the chronicles day and night,,
<next>
Travelling fool: That monk <topplayer> think he writes in golden ink, but his stories stink.

Drunk fool: Leprosy on him! Fango!`;
text[textConst.SECRETHOLDERINNFOOLMONK] = {
  Church: SECRETHOLDERINNFOOLMONK,
  Radical: SECRETHOLDERINNFOOLMONK,
  Wolf: SECRETHOLDERINNFOOLMONK
}

const SECRETHOLDERINNFOOLSCHOLAR = `Travelling fool: The scholars got the best stories, oh yes, how to beat them?

Poor fool: Hard to beat, no?, Smart olde brains.. 
<next>
Drunk fool: Let me tell you this.. A scholars’ tale a day..,, keeps my brain cancer awake,,...
<next>
Drunk fool: Gog help us..,, the scholars semper win..
<next>
Poor fool: We’ll end up plagued in mud together with <worstplayer>. Like chronicle 14, yes, "the coming intelligence plague us and turn us into undead!!"
<next>
Travelling fool: This scholar <topplayer> and his enchanting ink... what do we lack that he has?

Travelling fool: Stale breath and favours!
<next>
Drunk fool: *𝐥𝐨𝐨𝐤𝐢𝐧𝐠 𝐚𝐫𝐨𝐮𝐧𝐝* smells like <worstplayer> and his muddy stories!
<next>
Poor Fool: Mud’s upon us,,, it'll be like 1169 all over again..
<next>
Fools: *𝐡𝐢𝐜𝐜𝐮𝐩𝐬* ..Only gog can judge us..`;
text[textConst.SECRETHOLDERINNFOOLSCHOLAR] = {
  Church: SECRETHOLDERINNFOOLSCHOLAR,
  Radical: SECRETHOLDERINNFOOLSCHOLAR,
  Wolf: SECRETHOLDERINNFOOLSCHOLAR
}

const SECRETHOLDERINNFOOLFOOL = `Drunk fool: Toniiight we driink plenthy

Poor fool: And what about <worstplayer>?

Drunk fool: Mud and ficoseccus!
<next>
Travelling fool: The people sure love our tales, yes, yes,,
But this is just a device to pick apples and mushrooms, you fools! Check chronicle 38!
<next>
Poor fool: That old gilded fool <topplayer>, he got the best tongue!
<next>
Drunk Fool: *𝐛𝐮𝐮𝐮𝐫𝐩*
<next>
Travelling fool: me wrote a songe..,, it says:
𝓭𝓸𝔀𝓷 𝔀𝓲𝓽𝓱 𝓽𝓱𝓮 𝓶𝓸𝓷𝓴
𝓭𝓸𝔀𝓷 𝔀𝓲𝓽𝓱 𝓽𝓱𝓮 𝓫𝓻𝓪𝓲𝓷
𝓭𝓸𝔀𝓷 𝓽𝓱𝓮 𝓬𝓱𝓪𝓶𝓹𝓪𝓰𝓷𝓮!`;
text[textConst.SECRETHOLDERINNFOOLFOOL] = {
  Church: SECRETHOLDERINNFOOLFOOL,
  Radical: SECRETHOLDERINNFOOLFOOL,
  Wolf: SECRETHOLDERINNFOOLFOOL
}

const DRUNKINNMONKMONK = `Abbot: <username> right? Stop drinking in sorrows. Stop praying in vain. You can't fight God. When writing your story all you need doing is say you accept Him. Surrender to its truth and you'll find your answers.
<next><username>: *𝐡𝐢𝐜𝐜𝐮𝐩*`;
text[textConst.DRUNKINNMONKMONK] = {
  Church: DRUNKINNMONKMONK,
  Radical: DRUNKINNMONKMONK,
  Wolf: DRUNKINNMONKMONK
}

const DRUNKINNMONKSCHOLAR = `Abbot: <username> right? Stop drinking in sorrows. Stop praying in vain. You can't fight God. When writing your story all you need doing is say you accept Him. Surrender to its truth and you'll find your answers.
<next><username>: *𝐡𝐢𝐜𝐜𝐮𝐩*`;
text[textConst.DRUNKINNMONKSCHOLAR] = {
  Church: DRUNKINNMONKSCHOLAR,
  Radical: DRUNKINNMONKSCHOLAR,
  Wolf: DRUNKINNMONKSCHOLAR
}

const DRUNKINNMONKFOOL = `Abbot: <username> right? Stop drinking in sorrows. Stop praying in vain. You can't fight God. When writing your story all you need doing is say you accept Him. Surrender to its truth and you'll find your answers.
<next><username>: *𝐡𝐢𝐜𝐜𝐮𝐩*`;
text[textConst.DRUNKINNMONKFOOL] = {
  Church: DRUNKINNMONKFOOL,
  Radical: DRUNKINNMONKFOOL,
  Wolf: DRUNKINNMONKFOOL
}

const DRUNKINNSCHOLARMONK = `Italian Scholar: <username>. No need to get drunk to see what's going on here. What's in the chronicle isn't just knowledge, it's the engine of what's next. It is science. It is the end for the monks. It changes everything. Write about that future, transformative, a certain break with the past. You'll find your answers there.
<next><username>: *𝐡𝐢𝐜𝐜𝐮𝐩*`;
text[textConst.DRUNKINNSCHOLARMONK] = {
  Church: DRUNKINNSCHOLARMONK,
  Radical: DRUNKINNSCHOLARMONK,
  Wolf: DRUNKINNSCHOLARMONK
}

const DRUNKINNSCHOLARSCHOLAR = `Italian Scholar: <username>. No need to get drunk to see what's going on here. What's in the chronicle isn't just knowledge, it's the engine of what's next. It is science. It is the end for the monks. It changes everything. Write about that future, transformative, a certain break with the past. You'll find your answers there.
<next><username>: *𝐡𝐢𝐜𝐜𝐮𝐩*`;
text[textConst.DRUNKINNSCHOLARSCHOLAR] = {
  Church: DRUNKINNSCHOLARSCHOLAR,
  Radical: DRUNKINNSCHOLARSCHOLAR,
  Wolf: DRUNKINNSCHOLARSCHOLAR
}

const DRUNKINNSCHOLARFOOL = `Italian Scholar: <username>. No need to get drunk to see what's going on here. What's in the chronicle isn't just knowledge, it's the engine of what's next. It is science. It is the end for the monks. It changes everything. Write about that future, transformative, a certain break with the past. You'll find your answers there.
<next><username>: *𝐡𝐢𝐜𝐜𝐮𝐩*`;
text[textConst.DRUNKINNSCHOLARFOOL] = {
  Church: DRUNKINNSCHOLARFOOL,
  Radical: DRUNKINNSCHOLARFOOL,
  Wolf: DRUNKINNSCHOLARFOOL
}

const DRUNKINNFOOLMONK = `Travelling Fool: *𝐡𝐢𝐜𝐜𝐮𝐩* call it god *𝐡𝐢𝐜𝐜𝐮𝐩* call it a machine.. who cares!!

look at the mess the monks and scholars are making.. that's the story yes! Write about this madness, si, the chaos, yes.. and you may just find your answer
<next><username>:*𝐝𝐫𝐮𝐧𝐤 𝐥𝐚𝐮𝐠𝐡*`;
text[textConst.DRUNKINNFOOLMONK] = {
  Church: DRUNKINNFOOLMONK,
  Radical: DRUNKINNFOOLMONK,
  Wolf: DRUNKINNFOOLMONK
}

const DRUNKINNFOOLSCHOLAR = `Travelling Fool: *𝐡𝐢𝐜𝐜𝐮𝐩* call it god *𝐡𝐢𝐜𝐜𝐮𝐩* call it a machine.. who cares!!

look at the mess the monks and scholars are making.. that's the story yes! Write about this madness, si, the chaos, yes.. and you may just find your answer
<next><username>:*𝐝𝐫𝐮𝐧𝐤 𝐥𝐚𝐮𝐠𝐡*`;
text[textConst.DRUNKINNFOOLSCHOLAR] = {
  Church: DRUNKINNFOOLSCHOLAR,
  Radical: DRUNKINNFOOLSCHOLAR,
  Wolf: DRUNKINNFOOLSCHOLAR
}

const DRUNKINNFOOLFOOL = `Travelling Fool: *𝐡𝐢𝐜𝐜𝐮𝐩* call it god *𝐡𝐢𝐜𝐜𝐮𝐩* call it a machine.. who cares!!

look at the mess the monks and scholars are making.. that's the story yes! Write about this madness, si, the chaos, yes.. and you may just find your answer
<next><username>:*𝐝𝐫𝐮𝐧𝐤 𝐥𝐚𝐮𝐠𝐡*`;
text[textConst.DRUNKINNFOOLFOOL] = {
  Church: DRUNKINNFOOLFOOL,
  Radical: DRUNKINNFOOLFOOL,
  Wolf: DRUNKINNFOOLFOOL
}

const SECRET_ONE = `...... .... You are ready... to accept.... the truth.... behind the chronicles....

Follow me.... and you'll see it with your own eyes... Follow me...  you will be freed from Fango's mud...`;
text[textConst.SECRET_ONE] = {
  Church: SECRET_ONE,
  Radical: SECRET_ONE,
  Wolf: SECRET_ONE
}

const SECRET_TWO = `...... .... You are ready... to accept.... the truth.... behind the chronicles....

Follow me.... and you'll see it with your own eyes... Follow me...  you will be freed from Fango's mud...`;
text[textConst.SECRET_TWO] = {
  Church: SECRET_TWO,
  Radical: SECRET_TWO,
  Wolf: SECRET_TWO
}

const SECRET_THREE = `...... .... You are ready... to accept.... the truth.... behind the chronicles....

Follow me.... and you'll see it with your own eyes... Follow me...  you will be freed from Fango's mud...`;
text[textConst.SECRET_THREE] = {
  Church: SECRET_THREE,
  Radical: SECRET_THREE,
  Wolf: SECRET_THREE
}

text[textConst.TRANSACTIONFAIL] = {
  Church: `Brother, our records suggest you have not kept up to date with your contributions to the Abbot's fund...
  
(Action could not be completed. Check and top up your gas balance)`,
  Radical: `My friend, you know nothing is free these days...
  
(Action could not be completed. Check and top up your gas balance)`,
  Wolf: `What?! Empty pockets!

(Action could not be completed. Check and top up your gas balance)`
}

export const getGuideText = ( faction, constant, find=[] ) => {  
  //console.log( 'getGuideText() faction:', faction, 'const:', constant, Object.keys(textConst)[Object.values(textConst).indexOf(constant)] );
  if( !faction || typeof constant !== 'number' ){
    return '';
  }
  let out = text[constant][faction];
  if( Array.isArray( out ) ){
    out = out[ Math.floor( Math.random() * out.length ) ];
  }
  if( !!find ){
     find.forEach( ({find, replace}) => {
      const replaceUse = (replace) ? replace : '';
      const re = new RegExp(`${find}`, 'g');
      out = out.replace( re, replaceUse );
    }); 
  }
  if( out.indexOf( '<next>' ) !== -1 ){
    out = out.split('<next>');
  }
  //console.log( 'getGuideText() result: ', out );
  return out;
}

export const getChronicleTypeComment = ( seedId ) => {
  const type = epochTypes[seedId];
  const comments = {
    "Empty": "This one’s short..",
    "Censored": `Looks like someone censored it.`,
    "Corrupted": "",
    "Died": "rip †",
    "Cheated": "Rather unique..",
    "Memory": "What have we uncovered...",
    "exceptionalData": "",
    "powerfulNumber": "",
    "trainingComplete": "Looks like training complete?",
    "Stage0": "I see...",
    "Stage0-1": "",
    "Stage2progress": "",
    "Stage2mistakes": "",
    "Stage3-6": "RIP."
  }
  return (comments[type]) ? comments[type] : '';
}